import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(iterateMap),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(iterateSet),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(iterateImSet),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(iterateImArray),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(iterateArray),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(iterateObject),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(iterateImObject);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isarray, isindex } from "./array.js";
import inspectExpanded from "./expanded.js";
import formatSymbol from "./formatSymbol.js";
import inspectName from "./inspectName.js";
import { inspect, replace } from "./inspect.js";
import { isown, symbolsof, tagof, valueof } from "./object.js";
import { immutableName } from "./immutable.js";

function hasSelection(elem) {
  var sel = window.getSelection();
  return sel.type === "Range" && (sel.containsNode(elem, true) || sel.anchorNode.isSelfOrDescendant(elem) || sel.focusNode.isSelfOrDescendant(elem));
}

export default function inspectCollapsed(object, shallow, name, proto) {
  var arrayish = isarray(object);
  var tag, fields, next, n;

  if (object instanceof Map) {
    if (object instanceof object.constructor) {
      tag = "Map(".concat(object.size, ")");
      fields = iterateMap;
    } else {
      // avoid incompatible receiver error for prototype
      tag = "Map()";
      fields = iterateObject;
    }
  } else if (object instanceof Set) {
    if (object instanceof object.constructor) {
      tag = "Set(".concat(object.size, ")");
      fields = iterateSet;
    } else {
      // avoid incompatible receiver error for prototype
      tag = "Set()";
      fields = iterateObject;
    }
  } else if (arrayish) {
    tag = "".concat(object.constructor.name, "(").concat(object.length, ")");
    fields = iterateArray;
  } else if (n = immutableName(object)) {
    tag = "Immutable.".concat(n.name).concat(n.name === 'Record' ? '' : "(".concat(object.size, ")"));
    arrayish = n.arrayish;
    fields = n.arrayish ? iterateImArray : n.setish ? iterateImSet : iterateImObject;
  } else {
    tag = tagof(object);
    fields = iterateObject;
  }

  if (shallow) {
    var _span = document.createElement("span");

    _span.className = "observablehq--shallow";

    if (name) {
      _span.appendChild(inspectName(name));
    }

    _span.appendChild(document.createTextNode(tag));

    _span.addEventListener("mouseup", function (event) {
      if (hasSelection(_span)) return;
      event.stopPropagation();
      replace(_span, inspectCollapsed(object));
    });

    return _span;
  }

  var span = document.createElement("span");
  span.className = "observablehq--collapsed";

  if (name) {
    span.appendChild(inspectName(name));
  }

  var a = span.appendChild(document.createElement("a"));
  a.innerHTML = "<svg width=8 height=8 class='observablehq--caret'>\n    <path d='M7 4L1 8V0z' fill='currentColor' />\n  </svg>";
  a.appendChild(document.createTextNode("".concat(tag).concat(arrayish ? " [" : " {")));
  span.addEventListener("mouseup", function (event) {
    if (hasSelection(span)) return;
    event.stopPropagation();
    replace(span, inspectExpanded(object, null, name, proto));
  }, true);
  fields = fields(object);

  for (var i = 0; !(next = fields.next()).done && i < 20; ++i) {
    if (i > 0) span.appendChild(document.createTextNode(", "));
    span.appendChild(next.value);
  }

  if (!next.done) span.appendChild(document.createTextNode(", …"));
  span.appendChild(document.createTextNode(arrayish ? "]" : "}"));
  return span;
}

function iterateMap(map) {
  var _iterator, _step, _step$value, key, value;

  return _regeneratorRuntime.wrap(function iterateMap$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _iterator = _createForOfIteratorHelper(map);
          _context.prev = 1;

          _iterator.s();

        case 3:
          if ((_step = _iterator.n()).done) {
            _context.next = 9;
            break;
          }

          _step$value = _slicedToArray(_step.value, 2), key = _step$value[0], value = _step$value[1];
          _context.next = 7;
          return formatMapField(key, value);

        case 7:
          _context.next = 3;
          break;

        case 9:
          _context.next = 14;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](1);

          _iterator.e(_context.t0);

        case 14:
          _context.prev = 14;

          _iterator.f();

          return _context.finish(14);

        case 17:
          return _context.delegateYield(iterateObject(map), "t1", 18);

        case 18:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 11, 14, 17]]);
}

function iterateSet(set) {
  var _iterator2, _step2, value;

  return _regeneratorRuntime.wrap(function iterateSet$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _iterator2 = _createForOfIteratorHelper(set);
          _context2.prev = 1;

          _iterator2.s();

        case 3:
          if ((_step2 = _iterator2.n()).done) {
            _context2.next = 9;
            break;
          }

          value = _step2.value;
          _context2.next = 7;
          return inspect(value, true);

        case 7:
          _context2.next = 3;
          break;

        case 9:
          _context2.next = 14;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](1);

          _iterator2.e(_context2.t0);

        case 14:
          _context2.prev = 14;

          _iterator2.f();

          return _context2.finish(14);

        case 17:
          return _context2.delegateYield(iterateObject(set), "t1", 18);

        case 18:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 11, 14, 17]]);
}

function iterateImSet(set) {
  var _iterator3, _step3, value;

  return _regeneratorRuntime.wrap(function iterateImSet$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _iterator3 = _createForOfIteratorHelper(set);
          _context3.prev = 1;

          _iterator3.s();

        case 3:
          if ((_step3 = _iterator3.n()).done) {
            _context3.next = 9;
            break;
          }

          value = _step3.value;
          _context3.next = 7;
          return inspect(value, true);

        case 7:
          _context3.next = 3;
          break;

        case 9:
          _context3.next = 14;
          break;

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](1);

          _iterator3.e(_context3.t0);

        case 14:
          _context3.prev = 14;

          _iterator3.f();

          return _context3.finish(14);

        case 17:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 11, 14, 17]]);
}

function iterateImArray(array) {
  var i0, i1, n;
  return _regeneratorRuntime.wrap(function iterateImArray$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          i0 = -1, i1 = 0;
          n = array.size;

        case 2:
          if (!(i1 < n)) {
            _context4.next = 12;
            break;
          }

          if (!(i1 > i0 + 1)) {
            _context4.next = 6;
            break;
          }

          _context4.next = 6;
          return formatEmpty(i1 - i0 - 1);

        case 6:
          _context4.next = 8;
          return inspect(array.get(i1), true);

        case 8:
          i0 = i1;

        case 9:
          ++i1;
          _context4.next = 2;
          break;

        case 12:
          if (!(i1 > i0 + 1)) {
            _context4.next = 15;
            break;
          }

          _context4.next = 15;
          return formatEmpty(i1 - i0 - 1);

        case 15:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function iterateArray(array) {
  var i0, i1, n, key, _iterator4, _step4, symbol;

  return _regeneratorRuntime.wrap(function iterateArray$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          i0 = -1, i1 = 0;
          n = array.length;

        case 2:
          if (!(i1 < n)) {
            _context5.next = 13;
            break;
          }

          if (!(i1 in array)) {
            _context5.next = 10;
            break;
          }

          if (!(i1 > i0 + 1)) {
            _context5.next = 7;
            break;
          }

          _context5.next = 7;
          return formatEmpty(i1 - i0 - 1);

        case 7:
          _context5.next = 9;
          return inspect(valueof(array, i1), true);

        case 9:
          i0 = i1;

        case 10:
          ++i1;
          _context5.next = 2;
          break;

        case 13:
          if (!(i1 > i0 + 1)) {
            _context5.next = 16;
            break;
          }

          _context5.next = 16;
          return formatEmpty(i1 - i0 - 1);

        case 16:
          _context5.t0 = _regeneratorRuntime.keys(array);

        case 17:
          if ((_context5.t1 = _context5.t0()).done) {
            _context5.next = 24;
            break;
          }

          key = _context5.t1.value;

          if (!(!isindex(key) && isown(array, key))) {
            _context5.next = 22;
            break;
          }

          _context5.next = 22;
          return formatField(key, valueof(array, key), "observablehq--key");

        case 22:
          _context5.next = 17;
          break;

        case 24:
          _iterator4 = _createForOfIteratorHelper(symbolsof(array));
          _context5.prev = 25;

          _iterator4.s();

        case 27:
          if ((_step4 = _iterator4.n()).done) {
            _context5.next = 33;
            break;
          }

          symbol = _step4.value;
          _context5.next = 31;
          return formatField(formatSymbol(symbol), valueof(array, symbol), "observablehq--symbol");

        case 31:
          _context5.next = 27;
          break;

        case 33:
          _context5.next = 38;
          break;

        case 35:
          _context5.prev = 35;
          _context5.t2 = _context5["catch"](25);

          _iterator4.e(_context5.t2);

        case 38:
          _context5.prev = 38;

          _iterator4.f();

          return _context5.finish(38);

        case 41:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[25, 35, 38, 41]]);
}

function iterateObject(object) {
  var key, _iterator5, _step5, symbol;

  return _regeneratorRuntime.wrap(function iterateObject$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.t0 = _regeneratorRuntime.keys(object);

        case 1:
          if ((_context6.t1 = _context6.t0()).done) {
            _context6.next = 8;
            break;
          }

          key = _context6.t1.value;

          if (!isown(object, key)) {
            _context6.next = 6;
            break;
          }

          _context6.next = 6;
          return formatField(key, valueof(object, key), "observablehq--key");

        case 6:
          _context6.next = 1;
          break;

        case 8:
          _iterator5 = _createForOfIteratorHelper(symbolsof(object));
          _context6.prev = 9;

          _iterator5.s();

        case 11:
          if ((_step5 = _iterator5.n()).done) {
            _context6.next = 17;
            break;
          }

          symbol = _step5.value;
          _context6.next = 15;
          return formatField(formatSymbol(symbol), valueof(object, symbol), "observablehq--symbol");

        case 15:
          _context6.next = 11;
          break;

        case 17:
          _context6.next = 22;
          break;

        case 19:
          _context6.prev = 19;
          _context6.t2 = _context6["catch"](9);

          _iterator5.e(_context6.t2);

        case 22:
          _context6.prev = 22;

          _iterator5.f();

          return _context6.finish(22);

        case 25:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[9, 19, 22, 25]]);
}

function iterateImObject(object) {
  var _iterator6, _step6, _step6$value, key, value;

  return _regeneratorRuntime.wrap(function iterateImObject$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _iterator6 = _createForOfIteratorHelper(object);
          _context7.prev = 1;

          _iterator6.s();

        case 3:
          if ((_step6 = _iterator6.n()).done) {
            _context7.next = 9;
            break;
          }

          _step6$value = _slicedToArray(_step6.value, 2), key = _step6$value[0], value = _step6$value[1];
          _context7.next = 7;
          return formatField(key, value, "observablehq--key");

        case 7:
          _context7.next = 3;
          break;

        case 9:
          _context7.next = 14;
          break;

        case 11:
          _context7.prev = 11;
          _context7.t0 = _context7["catch"](1);

          _iterator6.e(_context7.t0);

        case 14:
          _context7.prev = 14;

          _iterator6.f();

          return _context7.finish(14);

        case 17:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7, null, [[1, 11, 14, 17]]);
}

function formatEmpty(e) {
  var span = document.createElement("span");
  span.className = "observablehq--empty";
  span.textContent = e === 1 ? "empty" : "empty \xD7 ".concat(e);
  return span;
}

function formatField(key, value, className) {
  var fragment = document.createDocumentFragment();
  var span = fragment.appendChild(document.createElement("span"));
  span.className = className;
  span.textContent = key;
  fragment.appendChild(document.createTextNode(": "));
  fragment.appendChild(inspect(value, true));
  return fragment;
}

function formatMapField(key, value) {
  var fragment = document.createDocumentFragment();
  fragment.appendChild(inspect(key, true));
  fragment.appendChild(document.createTextNode(" => "));
  fragment.appendChild(inspect(value, true));
  return fragment;
}